import React from "react";
import DataService from "../services/DataService";
import ViewMenuDiscriptionModel from "./modals/ViewMenuDiscriptionModal";
import BundleItemSelectionModal from "./modals/BundleItemSelectionModal";

class DishPreview extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.dataHandler = new DataService("restaurants");
		this.state = {
			showMenuProfile: true,
			itemSelected: null,
			parentVariantDish: null,
		};
		this.reloadFoodData = this.reloadFoodData.bind(this);

		this.reloadFoodData(this.props.dishId);
	}

	reloadFoodData = (id) => {
		let name = this.props.pathName;
		let inputParams = { name: name, id: id };
		this.dataHandler.getFoodProfile(inputParams).then((response) => {
			let foodObj = response.data.data;
			this.setState({
				showMenuProfile: true,
				itemSelected: foodObj,
				parentVariantDish: foodObj,
			});
		});
	};

	handleVariantSelection = (variant) => {
		if (!variant) {
			variant = this.state.parentVariantDish;
		}
		this.setState({ itemSelected: variant });
	};

	hideMenuProfile = () => {};

	render() {
		return this.state.itemSelected ? (
			<>
				<ViewMenuDiscriptionModel
					preview={true}
					// decreaseItem={this.decreaseItem}
					// incrementItem={this.incrementItem}
					// getQty={this.getQty}
					show={
						this.state.showMenuProfile &&
						!this.state.itemSelected.is_combo
					}
					onHide={this.hideMenuProfile}
					itemSelected={this.state.itemSelected}
					parentVariantDish={this.state.parentVariantDish}
					// setCustomaize={this.setCustomaize}
					// default_food_item_image={
					// 	this.state.profile.default_food_item_image
					// }
					handleVariantSelection={this.handleVariantSelection}
				/>
				{this.state.showMenuProfile && this.state.itemSelected.is_combo && (
					<BundleItemSelectionModal
						preview={true}
						parentVariantDish={this.state.parentVariantDish}
						showModal={true}
						onHide={this.hideMenuProfile}
						itemSelected={this.state.itemSelected}
						// default_food_item_image={
						// 	this.state.profile.default_food_item_image
						// }
						// wholeFoodItemList={
						// 	this.state.categories
						// 		? this.state.categories.flatMap(
						// 				(catObj) => catObj.foods_displayed_in_menu
						// 		  )
						// 		: []
						// }
						// decreaseItem={this.decreaseItem}
						// incrementItem={this.incrementItem}
						// setCustomaize={this.setCustomaize}
						{...this.props}
						handleVariantSelection={this.handleVariantSelection}
						// modeOfDelevery={this.state.modeOfDelevery}
					/>
				)}
			</>
		) : (
			<div
				className="d-flex justify-content-center align-items-center"
				style={{ height: "100vh" }}
			>
				<div
					className="spinner-border text-dark"
					role="status"
					style={{ width: "3rem", height: "3rem" }}
				>
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		);
	}
}

export default DishPreview;
